import LoyaltyMeta from "../Meta/LoyaltyMeta";
import LeaderboardModel from "./LeaderboardModel";

export default class LeaderboardResponseModel {
  public meta: LoyaltyMeta = new LoyaltyMeta();
  public data: LeaderboardModel[] = [];
}
